// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"04c800a7","787":"1ed0c42c","911":"4080a498"}[chunkId] + ".chunk.js";
};